export enum EntityType
{
    Division = 1,
    Person = 2,
    Access = 3,
    ServiceAccount = 4,
    Vehicle = 5,
    Sensor = 6,
    SensorExcess = 7,
    Report = 8,
    Dashboard = 9,
    Alarm = 10
}

const keys = Object.keys(EntityType).map(k => EntityType[k]);

export const EntityTypeNames = keys.filter(v => typeof v === 'string');
export const EntityTypeValues = keys.filter(v => typeof v === 'number');




// WEBPACK FOOTER //
// ./src/models/EntityType.ts